module.exports = __webpack_public_path__ + "img/assembling-machine-1-shadow.e0556c5e.png";